import * as React from "react";

export function GoogleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" {...props}>
      <path
        fill="#EA4335"
        d="M12 10.8v3.7h5.2c-.2 1.3-.9 2.4-1.9 3.1l3.1 2.4c1.8-1.7 2.8-4.1 2.8-7 0-.6-.1-1.2-.2-1.8H12z"
      />
      <path
        fill="#34A853"
        d="M6.5 14.3c-.3-.9-.5-1.9-.5-2.9s.2-2 .5-2.9L3.4 6.1A11.93 11.93 0 0 0 0 11.4c0 2.1.6 4.1 1.7 5.8l3-2.9z"
      />
      <path
        fill="#4A90E2"
        d="M12 24c3.2 0 5.9-1.1 7.9-3l-3.1-2.4c-.9.6-2.1 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1l-3.1 2.9C6 21.9 8.8 24 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M12 4.8c1.7 0 3.2.6 4.4 1.9l3.3-3.3C17.9 1.2 15.2 0 12 0 7.8 0 4.1 2.5 1.7 6.1l3.1 2.4c.8-2.3 3-3.7 5.2-3.7z"
      />
    </svg>
  );
}

